import { render, staticRenderFns } from "./FirefoxIcon.vue?vue&type=template&id=6f4b7886&scoped=true"
import script from "./FirefoxIcon.vue?vue&type=script&lang=js"
export * from "./FirefoxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4b7886",
  null
  
)

export default component.exports